// import React, { useState, useEffect } from "react";
// import "./hlc-blog.css";
// import Navbar from "../components/Navbar";
// import HlcFooter from "../components/HlcFooter";
// import { useNavigate } from "react-router-dom";
// import { initializeApp, getApps } from "firebase/app";
// import {
//   getDatabase,
//   ref as dbRef,
//   onValue,
//   push,
// } from "firebase/database";

// import { db } from "../firebase";


// const POSTS_PER_PAGE_DEFAULT = 6;

// export default function HlcBlogPage() {
//   const navigate = useNavigate();

//   const [posts, setPosts] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [settings, setSettings] = useState({
//     siteTitle: "HLC BLOG",
//     tagline: "Lighting Ideas, Guides & Industry Insights",
//     newsletterEnabled: true,
//     postsPerPage: POSTS_PER_PAGE_DEFAULT,
//   });
//   const [loading, setLoading] = useState(true);

//   const [activeTab, setActiveTab] = useState("All");
//   const [searchQ, setSearchQ] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);

//   // Newsletter
//   const [email, setEmail] = useState("");
//   const [subscribed, setSubscribed] = useState(false);

//   // ── Firebase listeners ──────────────────────────────────────────────────────
//   useEffect(() => {
//     const postsRef = dbRef(db, "blogs");
//     const unsubPosts = onValue(postsRef, (snap) => {
//       const data = snap.val();
//       if (!data) { setPosts([]); setLoading(false); return; }
//       const parsed = Object.keys(data)
//         .map((id) => ({ id, ...data[id] }))
//         .filter((p) => p.published)
//         .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
//       setPosts(parsed);
//       setLoading(false);
//     });

//     const catRef = dbRef(db, "categories");
//     const unsubCat = onValue(catRef, (snap) => {
//       const data = snap.val();
//       if (!data) { setCategories([]); return; }
//       setCategories(
//         Object.keys(data).map((id) => ({
//           id,
//           ...data[id],
//           subcategories: data[id].subcategories
//             ? Object.keys(data[id].subcategories).map((sid) => ({
//                 id: sid,
//                 ...data[id].subcategories[sid],
//               }))
//             : [],
//         }))
//       );
//     });

//     const settingsRef = dbRef(db, "blogSettings");
//     const unsubSettings = onValue(settingsRef, (snap) => {
//       const data = snap.val();
//       if (data) setSettings((prev) => ({ ...prev, ...data }));
//     });

//     return () => { unsubPosts(); unsubCat(); unsubSettings(); };
//   }, []);

//   // ── Derived data ────────────────────────────────────────────────────────────
//   const featuredPost = posts.find((p) => p.featured) || posts[0];

//   // Blog-specific tab labels from actual post categories
//   const blogCategoryTabs = [
//     "All",
//     ...Array.from(new Set(posts.map((p) => p.category).filter(Boolean))),
//   ];

//   const filteredPosts = posts.filter((p) => {
//     if (p.id === featuredPost?.id) return false; // exclude featured from grid
//     const matchTab = activeTab === "All" || p.category === activeTab;
//     const matchQ = !searchQ ||
//       p.title?.toLowerCase().includes(searchQ.toLowerCase()) ||
//       p.excerpt?.toLowerCase().includes(searchQ.toLowerCase());
//     return matchTab && matchQ;
//   });

//   const postsPerPage = settings.postsPerPage || POSTS_PER_PAGE_DEFAULT;
//   const totalPages = Math.ceil(filteredPosts.length / postsPerPage);
//   const paginatedPosts = filteredPosts.slice(
//     (currentPage - 1) * postsPerPage,
//     currentPage * postsPerPage
//   );

//   const recentPosts = posts.slice(0, 3);

//   // ── Newsletter subscribe ────────────────────────────────────────────────────
//   const handleSubscribe = async (e) => {
//     e.preventDefault();
//     if (!email.trim()) return;
//     try {
//       await push(dbRef(db, "newsletter"), {
//         email: email.trim(),
//         subscribedAt: Date.now(),
//       });
//       setSubscribed(true);
//       setEmail("");
//     } catch (err) {
//       console.error("Newsletter error:", err);
//     }
//   };

//   // ── Tab/search reset page ───────────────────────────────────────────────────
//   const handleTabChange = (tab) => {
//     setActiveTab(tab);
//     setCurrentPage(1);
//   };
//   const handleSearch = (e) => {
//     setSearchQ(e.target.value);
//     setCurrentPage(1);
//   };

//   // ═══════════════════════════════════════════════════════════════════════════
//   return (
//     <>
//       <Navbar />
//       <section className="hlc-blog-page" id="hlc-blog">
//         <div className="hlc-blog-inner">

//           {/* ── Hero ── */}
//           <header className="hlc-blog-hero">
//             <span>HLC BLOG</span>
//             <h1>{settings.tagline || "Lighting Ideas, Guides & Industry Insights"}</h1>
//             <p>
//               Explore expert tips, LED lighting trends, energy-saving guides and product insights
//               for homes, offices, shops and commercial spaces.
//             </p>
//           </header>

//           {/* ── Tabs ── */}
//           <div className="hlc-blog-tabs">
//             {blogCategoryTabs.map((tab) => (
//               <button
//                 key={tab}
//                 className={activeTab === tab ? "active" : ""}
//                 onClick={() => handleTabChange(tab)}
//               >
//                 {tab}
//               </button>
//             ))}
//           </div>

//           {/* ── Loading ── */}
//           {loading && (
//             <div className="hlc-blog-loading">
//               <div className="hlc-spinner"></div>
//               <p>Loading posts...</p>
//             </div>
//           )}

//           {/* ── Featured Post ── */}
//           {!loading && featuredPost && (
//             <article className="hlc-featured-blog">
//               <div className="hlc-featured-img">
//                 <img
//                   src={featuredPost.image || "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=80"}
//                   alt={featuredPost.title}
//                 />
//               </div>
//               <div className="hlc-featured-content">
//                 <span className="blog-badge">Featured Article</span>
//                 <h2>{featuredPost.title}</h2>
//                 <p>{featuredPost.excerpt}</p>
//                 <div className="blog-meta">
//                   <span>{featuredPost.category}</span>
//                   <span>{featuredPost.readTime || "5 min read"}</span>
//                 </div>
//                 <button
//                   onClick={() => navigate("/single-blog", { state: { postId: featuredPost.id } })}
//                   className="blog-btn"
//                 >
//                   Read More
//                 </button>
//               </div>
//             </article>
//           )}

//           {/* ── Main layout ── */}
//           {!loading && (
//             <div className="hlc-blog-layout">

//               <main className="hlc-blog-main">
//                 {paginatedPosts.length === 0 ? (
//                   <div className="hlc-blog-empty">
//                     <p>No posts found{searchQ ? ` for "${searchQ}"` : ""}.</p>
//                   </div>
//                 ) : (
//                   <div className="hlc-blog-grid">
//                     {paginatedPosts.map((post) => (
//                       <article key={post.id} className="hlc-blog-card">
//                         <div className="blog-img">
//                           <img
//                             src={post.image || "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=800&q=80"}
//                             alt={post.title}
//                           />
//                         </div>
//                         <div className="blog-content">
//                           <span>{post.category}</span>
//                           <h3>{post.title}</h3>
//                           <p>{post.excerpt}</p>
//                           <button
//                             onClick={() => navigate("/single-blog", { state: { postId: post.id } })}
//                           >
//                             Read More
//                           </button>
//                         </div>
//                       </article>
//                     ))}
//                   </div>
//                 )}

//                 {/* ── Pagination ── */}
//                 {totalPages > 1 && (
//                   <div className="hlc-pagination">
//                     <button
//                       disabled={currentPage === 1}
//                       onClick={() => setCurrentPage(currentPage - 1)}
//                     >
//                       Prev
//                     </button>
//                     {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//                       <button
//                         key={page}
//                         className={currentPage === page ? "active" : ""}
//                         onClick={() => setCurrentPage(page)}
//                       >
//                         {page}
//                       </button>
//                     ))}
//                     <button
//                       disabled={currentPage === totalPages}
//                       onClick={() => setCurrentPage(currentPage + 1)}
//                     >
//                       Next
//                     </button>
//                   </div>
//                 )}
//               </main>

//               {/* ── Sidebar ── */}
//               <aside className="hlc-blog-sidebar">

//                 <div className="sidebar-box search-box">
//                   <h4>Search Articles</h4>
//                   <div className="sidebar-search-wrap">
//                     <input
//                       type="text"
//                       placeholder="Search blog..."
//                       value={searchQ}
//                       onChange={handleSearch}
//                     />

//                     <button className="search-box2" type="button">Search</button>
//                   </div>
//                 </div>

//                 <div className="sidebar-box">
//                   <h4>Categories</h4>
//                   <ul>
//                     {categories.length > 0
//                       ? categories.map((cat) => (
//                           <li key={cat.id}>
//                             <button
//                               className="sidebar-cat-link"
//                               onClick={() => handleTabChange(cat.title)}
//                             >
//                               {cat.title}
//                             </button>
//                           </li>
//                         ))
//                       : (
//                         <>
//                           {["LED Lighting", "Energy Saving", "Home Lighting", "Commercial Lighting", "Outdoor Lighting"].map((c) => (
//                             <li key={c}><button className="sidebar-cat-link" onClick={() => handleTabChange(c)}>{c}</button></li>
//                           ))}
//                         </>
//                       )
//                     }
//                   </ul>
//                 </div>

//                 <div className="sidebar-box">
//                   <h4>Recent Posts</h4>
//                   {recentPosts.map((post) => (
//                     <div
//                       key={post.id}
//                       className="recent-post"
//                       onClick={() => navigate("/single-blog", { state: { postId: post.id } })}
//                       style={{ cursor: "pointer" }}
//                     >
//                       {post.image && <img src={post.image} alt="" />}
//                       <span>{post.title}</span>
//                     </div>
//                   ))}
//                   {recentPosts.length === 0 && <p className="sidebar-empty">No posts yet.</p>}
//                 </div>

//               </aside>

//             </div>
//           )}

//           {/* ── Newsletter ── */}
//           {/* {settings.newsletterEnabled && (
//             <section className="hlc-blog-newsletter">
//               <h2>Stay Updated with HLC</h2>
//               <p>Get lighting tips, product updates and energy-saving guides directly in your inbox.</p>
//               {subscribed ? (
//                 <p className="newsletter-success">✅ Thank you for subscribing!</p>
//               ) : (
//                 <form onSubmit={handleSubscribe}>
//                   <input
//                     type="email"
//                     placeholder="Enter your email address"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     required
//                   />
//                   <button type="submit">Subscribe</button>
//                 </form>
//               )}
//             </section>
//           )} */}

//         </div>
//       </section>
//       <HlcFooter />
//     </>
//   );
// }

import React, { useState, useEffect } from "react";
import "./hlc-blog.css";
import Navbar from "../components/Navbar";
import HlcFooter from "../components/HlcFooter";
import { useNavigate } from "react-router-dom";

import { API_BASE_URL, getImageUrl } from "../config/apiConfig";


const POSTS_PER_PAGE_DEFAULT = 6;

export default function HlcBlogPage() {
  const navigate = useNavigate();

  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [settings, setSettings] = useState({
    siteTitle: "HLC BLOG",
    tagline: "Lighting Ideas, Guides & Industry Insights",
    newsletterEnabled: true,
    postsPerPage: POSTS_PER_PAGE_DEFAULT,
  });
  const [loading, setLoading] = useState(true);

  const [activeTab, setActiveTab] = useState("All");
  const [searchQ, setSearchQ] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  // Newsletter
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    fetch(`${API_BASE_URL}/api/public/categories/list.php`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        const parsed = Array.isArray(data)
          ? data.map((cat) => ({
              ...cat,
              subcategories: cat.subcategories
                ? Object.keys(cat.subcategories).map((sid) => cat.subcategories[sid])
                : [],
            }))
          : [];
        setCategories(parsed);
      })
      .catch((err) => {
        console.error("Failed to fetch categories:", err);
        if (!cancelled) setCategories([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  // ROLLBACK: blogSettings used to be fetched here via Firebase, alongside
  // blogs/categories above (all three in one combined effect, before Steps
  // 2-4 of the Firebase->PHP migration split them out individually).
  // const settingsRef = dbRef(db, "blogSettings");
  // const unsubSettings = onValue(settingsRef, (snap) => {
  //   const data = snap.val();
  //   if (data) setSettings((prev) => ({ ...prev, ...data }));
  // });

  // ── Blog posts from adminhlc-api (MySQL) — Step 3 of the Firebase->PHP migration ──
  useEffect(() => {
    let cancelled = false;

    fetch(`${API_BASE_URL}/api/public/blogs/list.php`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        const parsed = Array.isArray(data)
          ? data
              .map((p) => ({ ...p, image: getImageUrl(p.image) }))
              .filter((p) => p.published)
              .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
          : [];
        setPosts(parsed);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch blog posts:", err);
        if (!cancelled) {
          setPosts([]);
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  // ── Blog settings from adminhlc-api (MySQL) — Step 2 of the Firebase->PHP migration ──
  useEffect(() => {
    let cancelled = false;

    fetch(`${API_BASE_URL}/api/public/blogs/settings_get.php`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        if (data) setSettings((prev) => ({ ...prev, ...data }));
      })
      .catch((err) => {
        console.error("Failed to fetch blog settings:", err);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  // ── Derived data ────────────────────────────────────────────────────────────
  const featuredPost = posts.find((p) => p.featured) || posts[0];

  // Blog-specific tab labels from actual post categories
  const blogCategoryTabs = [
    "All",
    ...Array.from(new Set(posts.map((p) => p.category).filter(Boolean))),
  ];

  const filteredPosts = posts.filter((p) => {
    if (p.id === featuredPost?.id) return false; // exclude featured from grid
    const matchTab = activeTab === "All" || p.category === activeTab;
    const matchQ = !searchQ ||
      p.title?.toLowerCase().includes(searchQ.toLowerCase()) ||
      p.excerpt?.toLowerCase().includes(searchQ.toLowerCase());
    return matchTab && matchQ;
  });

  const postsPerPage = settings.postsPerPage || POSTS_PER_PAGE_DEFAULT;
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);
  const paginatedPosts = filteredPosts.slice(
    (currentPage - 1) * postsPerPage,
    currentPage * postsPerPage
  );

  const recentPosts = posts.slice(0, 3);

  // ── Newsletter subscribe: adminhlc-api (MySQL) — Step 6 of the Firebase->PHP migration ──
  // ROLLBACK: original Firebase implementation:
  // const handleSubscribe = async (e) => {
  //   e.preventDefault();
  //   if (!email.trim()) return;
  //   try {
  //     await push(dbRef(db, "newsletter"), {
  //       email: email.trim(),
  //       subscribedAt: Date.now(),
  //     });
  //     setSubscribed(true);
  //     setEmail("");
  //   } catch (err) {
  //     console.error("Newsletter error:", err);
  //   }
  // };
  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    try {
      const res = await fetch(`${API_BASE_URL}/api/public/newsletter/create.php`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ email: email.trim() }),
      });
      const data = await res.json();
      if (!res.ok) {
        console.error("Newsletter error:", data.error || res.statusText);
        return;
      }
      setSubscribed(true);
      setEmail("");
    } catch (err) {
      console.error("Newsletter error:", err);
    }
  };

  // ── Tab/search reset page ───────────────────────────────────────────────────
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
  };
  const handleSearch = (e) => {
    setSearchQ(e.target.value);
    setCurrentPage(1);
  };

  // ═══════════════════════════════════════════════════════════════════════════
  return (
    <>
      <Navbar />
      <section className="hlc-blog-page" id="hlc-blog">
        <div className="hlc-blog-inner">

          {/* ── Hero ── */}
          <header className="hlc-blog-hero">
            <span>HLC BLOG</span>
            <h1>{settings.tagline || "Lighting Ideas, Guides & Industry Insights"}</h1>
            <p>
              Explore expert tips, LED lighting trends, energy-saving guides and product insights
              for homes, offices, shops and commercial spaces.
            </p>
          </header>

          {/* ── Tabs ── */}
          <div className="hlc-blog-tabs">
            {blogCategoryTabs.map((tab) => (
              <button
                key={tab}
                className={activeTab === tab ? "active" : ""}
                onClick={() => handleTabChange(tab)}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* ── Loading ── */}
          {loading && (
            <div className="hlc-blog-loading">
              <div className="hlc-spinner"></div>
              <p>Loading posts...</p>
            </div>
          )}

          {/* ── Featured Post ── */}
          {!loading && featuredPost && (
            <article className="hlc-featured-blog">
              <div className="hlc-featured-img">
                <img
                  src={featuredPost.image || "https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=80"}
                  alt={featuredPost.title}
                />
              </div>
              <div className="hlc-featured-content">
                <span className="blog-badge">Featured Article</span>
                <h2>{featuredPost.title}</h2>
                <p>{featuredPost.excerpt}</p>
                <div className="blog-meta">
                  <span>{featuredPost.category}</span>
                  <span>{featuredPost.readTime || "5 min read"}</span>
                </div>
                <button
                  onClick={() => navigate("/single-blog", { state: { postId: featuredPost.id } })}
                  className="blog-btn"
                >
                  Read More
                </button>
              </div>
            </article>
          )}

          {/* ── Main layout ── */}
          {!loading && (
            <div className="hlc-blog-layout">

              <main className="hlc-blog-main">
                {paginatedPosts.length === 0 ? (
                  <div className="hlc-blog-empty">
                    <p>No posts found{searchQ ? ` for "${searchQ}"` : ""}.</p>
                  </div>
                ) : (
                  <div className="hlc-blog-grid">
                    {paginatedPosts.map((post) => (
                      <article key={post.id} className="hlc-blog-card">
                        <div className="blog-img">
                          <img
                            src={post.image || "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=800&q=80"}
                            alt={post.title}
                          />
                        </div>
                        <div className="blog-content">
                          <span>{post.category}</span>
                          <h3>{post.title}</h3>
                          <p>{post.excerpt}</p>
                          <button
                            onClick={() => navigate("/single-blog", { state: { postId: post.id } })}
                          >
                            Read More
                          </button>
                        </div>
                      </article>
                    ))}
                  </div>
                )}

                {/* ── Pagination ── */}
                {totalPages > 1 && (
                  <div className="hlc-pagination">
                    <button
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(currentPage - 1)}
                    >
                      Prev
                    </button>
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                      <button
                        key={page}
                        className={currentPage === page ? "active" : ""}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    ))}
                    <button
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage(currentPage + 1)}
                    >
                      Next
                    </button>
                  </div>
                )}
              </main>

              {/* ── Sidebar ── */}
              <aside className="hlc-blog-sidebar">

                <div className="sidebar-box search-box">
                  <h4>Search Articles</h4>
                  <div className="sidebar-search-wrap">
                    <input
                      type="text"
                      placeholder="Search blog..."
                      value={searchQ}
                      onChange={handleSearch}
                    />
                    <button className="search-box2" type="button">Search</button>
                  </div>
                </div>

                <div className="sidebar-box">
                  <h4>Categories</h4>
                  <ul>
                    {categories.length > 0
                      ? categories.map((cat) => (
                          <li key={cat.id}>
                            <button
                              className="sidebar-cat-link"
                              onClick={() => handleTabChange(cat.title)}
                            >
                              {cat.title}
                            </button>
                          </li>
                        ))
                      : (
                        <>
                          {["LED Lighting", "Energy Saving", "Home Lighting", "Commercial Lighting", "Outdoor Lighting"].map((c) => (
                            <li key={c}>
                              <button className="sidebar-cat-link" onClick={() => handleTabChange(c)}>
                                {c}
                              </button>
                            </li>
                          ))}
                        </>
                      )
                    }
                  </ul>
                </div>

                <div className="sidebar-box">
                  <h4>Recent Posts</h4>
                  {recentPosts.map((post) => (
                    <div
                      key={post.id}
                      className="recent-post"
                      onClick={() => navigate("/single-blog", { state: { postId: post.id } })}
                      style={{ cursor: "pointer" }}
                    >
                      {post.image && <img src={post.image} alt="" />}
                      <span>{post.title}</span>
                    </div>
                  ))}
                  {recentPosts.length === 0 && <p className="sidebar-empty">No posts yet.</p>}
                </div>

              </aside>

            </div>
          )}

          {/* ── Newsletter ── */}
          {settings.newsletterEnabled && (
            <section className="hlc-blog-newsletter">
              <h2>Stay Updated with HLC</h2>
              <p>Get lighting tips, product updates and energy-saving guides directly in your inbox.</p>
              {subscribed ? (
                <p className="newsletter-success">✅ Thank you for subscribing!</p>
              ) : (
                <form onSubmit={handleSubscribe}>
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit">Subscribe</button>
                </form>
              )}
            </section>
          )}

        </div>
      </section>
      <HlcFooter />
    </>
  );
}